export default "__VITE_ASSET__b4202bbe__"